import LayoutActividad from "../../../components/LayoutActividad";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo12/vehiculos.png";
import Imagen2 from "../../../images/modulo12/aulas.png";
import GuiaDocente from "../../../components/GuiaDocente";

const Actividad7 = () => {
  const infoUnidad = modulo12.content[1];
  const infoAct = modulo12.content[1].activities[8];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo12.content[1].name}: ${modulo12.content[1].activities[9].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[1].path}/${modulo12.content[1].activities[9].path}`,
    titlePrev: `${modulo12.content[1].name}: ${modulo12.content[1].activities[7].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[1].path}/${modulo12.content[1].activities[7].path}`,
  };
  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>

      <div className="bg-light p-3 p-md-5 mt-5">
        <div className="row mt-3 align-items-center">
          <div className="col-md-8 col-12 p-4 p-md-3">
          <h2 className="mb-4">¿Cómo se manifiesta la desigualdad?</h2>

            <p>
              La <strong>desigualdad</strong> en el Perú se puede ver en el
              acceso a bienes materiales y servicios como educación y salud de
              calidad.
            </p>
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen1} className="img-fluid w-100" alt="Peruanos" />
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen2} className="img-fluid w-100" alt="Peruanos" />
          </div>
          <div className="col-md-8 col-12 p-4 p-md-3">
            <p>
              Las personas con más dinero tienen más posibilidades para cubrir
              sus necesidades. Tienen <strong>oportunidades</strong> que otras
              personas no tienen. El Estado debe garantizar nuestros derechos y
              oportunidades por igual sin importar quiénes somos, dónde vivimos
              o en qué trabajamos.
            </p>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Pida a dos niños o niñas que lean el texto ¿Cómo se manifiesta la
            desigualdad? (cada uno un párrafo). Al terminar, lea usted todo el
            texto en voz alta.
          </li>
          <li>
            Pregunte qué es lo que nos dice el texto acerca de cómo se
            manifiesta la desigualdad en el país (acceso a salud y educación,
            por ejemplo). Cierre el tema señalando la importancia de reducir la
            desigualdad entre peruanos con el fin de que todos tengan las mismas
            oportunidades.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad7;
